<script>
  import HeaderNotificacoes from './header/Notificacoes'

  import * as authService from '../../services/authService'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'
  import {mapGetters, mapActions} from 'vuex'

  // import QRCode from 'qrcode'
  import bwipjs from 'bwip-js'

  export default {
    name: 'app-header',
    components: {HeaderNotificacoes},
    mixins: [helpers],
    data () {
      return {
        mensagens: [],
        eventos: [],
        mostrarModalQRCode: false,
        qrcodeBase64: ''
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'isLogged']),
      primeiroNome: function () {
        if (this.isLogged) {
          let nome = (this.currentUser.pessoa.nome.split(' ')[0] || '').toLowerCase()
          return nome.charAt(0).toUpperCase() + nome.slice(1)
        }
        return ''
      },
      avatar: function () {
        return this.isLogged ? this.currentUser.avatar : null
      }
    },
    methods: {
      ...mapActions(['toggleSidebar']),
      irParaMinhaConta () {
        this.$router.push({name: 'minha-conta.inicial'})
      },
      async gerarQRCodeCatracas () {
        // await QRCode.toCanvas(this.$refs.qrcode, this.currentUser.ref_pessoa.toString(), {width: 200})
        this.$nextTick(() => {
          bwipjs('barcode', {
            bcid: 'code128',
            text: this.currentUser.ref_pessoa.toString(),
            scale: 3,
            height: 20
          }, function (err) {
            if (err) {
              console.log('err', err)
            }
          })
          this.mostrarModalQRCode = true
        })
      },
      onLogout () {
        bus.$emit('show-loader')
        authService.logout()
          .then(() => {
            this.$router.push({name: 'login'})
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <header class="header-bar">
        <div class="toggle-menu" @click="toggleSidebar">
            <i class="fas fa-bars"></i>
        </div>
        <router-link :to="{name: 'dashboard'}" class="logo">
            <figure>
                <figcaption>SOU</figcaption>
                <img src="https://urcamp.edu.br/site/img/logos/logo-branco.png" alt="">
            </figure>
        </router-link>
        <div class="header-data">
            <header-notificacoes/>
            <div class="navegation">
                <nav class="menu-icons">
                    <div class="item-icon"
                         v-if="!!isMobile().any()"
                         @click="gerarQRCodeCatracas"
                         title="Acesso às Catracas">
                        <i class="fas fa-ticket-alt"></i>
                    </div>
                    <div class="user-info">
                        <div><span class="name">{{primeiroNome}}</span></div>
                        <div><strong>{{currentUser.ref_pessoa}}</strong></div>
                    </div>
                    <div class="dropmenu-header">
                        <v-menu offset-y :open-on-hover="true">
                            <div slot="activator">
                                <div class="item-icon user"
                                     key="headerAvatarSigla"
                                     :title="currentUser.pessoa.nome"
                                     v-if="!avatar">
                                    {{currentUser.sigla}}
                                </div>
                                <div class="user-avatar"
                                     key="headerAvatarImagem"
                                     :title="currentUser.pessoa.nome"
                                     v-if="avatar"
                                     v-bind:style="{ backgroundImage: 'url(' + avatar + ')' }">
                                </div>
                            </div>
                            <v-list>
                                <v-list-tile @click="irParaMinhaConta">
                                    <v-list-tile-title>
                                        <i class="fas fa-user"></i>
                                        <span class="ml-2">Minha Conta</span>
                                    </v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click="onLogout">
                                    <v-list-tile-title>
                                        <i class="fas fa-sign-out-alt"></i>
                                        <span class="ml-2">Sair</span>
                                    </v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </div>
                </nav>
            </div>
        </div>
        <v-dialog v-model="mostrarModalQRCode"
                  :fullscreen="true">
            <v-card>
                <div class="qrcode-box" @click="mostrarModalQRCode = !mostrarModalQRCode">
                    <div class="qrcode-message">
                        Coloque o brilho da tela do seu celular no máximo e aponte a tela para o leitor da catraca
                    </div>
                    <div>
                        <canvas ref="qrcode" id="qrcode" v-if="false"></canvas>
                        <canvas ref="barcode" id="barcode"></canvas>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </header>
</template>

<style lang="scss">
    .header-bar {
        width: 100vw;
        height: 80px;
        background: rgba(51, 68, 61, 1);
        background: -moz-linear-gradient(left, rgba(51, 68, 61, 1) 0%, rgba(59, 80, 71, 1) 100%);
        background: -webkit-gradient(left top, right top, color-stop(0%, rgba(51, 68, 61, 1)), color-stop(100%, rgba(59, 80, 71, 1)));
        background: -webkit-linear-gradient(left, rgba(51, 68, 61, 1) 0%, rgba(59, 80, 71, 1) 100%);
        background: -o-linear-gradient(left, rgba(51, 68, 61, 1) 0%, rgba(59, 80, 71, 1) 100%);
        background: -ms-linear-gradient(left, rgba(51, 68, 61, 1) 0%, rgba(59, 80, 71, 1) 100%);
        background: linear-gradient(to right, rgba(51, 68, 61, 1) 0%, rgba(59, 80, 71, 1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#33443d', endColorstr='#3b5047', GradientType=1);
        border-bottom: 5px solid #909E48;
        -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
        position: fixed;
        left: 0;
        top: 0;
        z-index: 180;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;

        .toggle-menu {
            display: none;
            width: 44px;
            height: 55px;
            text-align: center;
            color: #FFF;
            line-height: 55px;
            font-size: 21px;
            background-color: rgb(75, 104, 93);
        }

        .header-data {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex: 1;
        }

        > .logo {
            margin: 0;
            display: block;
            width: 200px;
            padding: 10px;
            text-decoration: none;
            background-color: #384f45;
            height: 75px;

            figcaption {
                text-align: center;
                color: #FFF;
                font-size: 18px;
                font-weight: 300;
            }

            img {
                position: relative;
                top: -15px;
                left: -5px;
                display: block;
                margin: 0 auto;
                max-width: 100%;
                max-height: 44px;
            }
        }

        .header-data {

            > .navegation {
                padding-right: 30px;
            }

            .header-data-title {
                color: #eeeeee;
                font-weight: 300;
                font-size: 38px;
            }

            .navegation,
            .notifications {

                .menu-icons {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    height: 75px;

                    .dropmenu-header {
                        width: 65px;
                    }

                    .item-icon {
                        width: 65px;
                        height: 75px;
                        line-height: 75px;
                        text-align: center;
                        color: #909E48;
                        font-size: 28px;
                        position: relative;

                        .badge-notify {
                            display: block;
                            position: absolute;
                            right: 5px;
                            bottom: 10px;
                            background-color: #e80000;
                            width: 18px;
                            height: 18px;
                            line-height: 18px;
                            color: #FFF;
                            font-size: 11px;
                            font-weight: bold;
                            text-align: center;
                            border-radius: 50%;
                        }

                        &.user {
                            background-color: rgba(0, 0, 0, 0.2);
                            color: #FFF;
                            text-decoration: none;
                            font-size: 20px;
                            font-weight: bold;
                            border-radius: 50%;
                            width: 55px;
                            height: 55px;
                            line-height: 55px;
                            margin-right: 0;
                            margin-left: 10px;
                            cursor: pointer;
                        }
                    }
                }

                .user-info {
                    font-size: 16px;
                    padding-right: 12px;
                    color: rgba(255, 255, 255, 0.7);
                    text-align: center;
                    line-height: 18px;

                    .name {
                        color: #FFF;
                    }

                    strong {
                        color: #bed160;
                        font-weight: 600;
                        font-size: 14px;
                    }
                }

                .user-avatar {
                    width: 55px;
                    height: 55px;
                    border-radius: 50%;
                    background-position: center;
                    background-size: cover;
                    background-repeat: no-repeat;
                    border: 2px solid #4b6a5d;
                    cursor: pointer;
                }
            }
        }
    }

    .qrcode-box {
        padding: 0 !important;
        height: 100vh;
        width: 100vw;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .qrcode-message {
            position: absolute;
            top: 20px;
            padding: 0 25px;
            font-size: 18px;
            text-align: center;
        }

        canvas {
            display: block;
            margin: 0 auto;

            &:last-child {
                margin-top: 45px;
            }
        }
    }

    @media all and (max-width: 1024px) {
        .header-bar {
            .header-data-title {
                display: none;
            }

            .toggle-menu {
                height: 75px;
                line-height: 75px;
                display: block;
            }

            .logo {
                width: 170px;
            }
        }
    }

    @media all and (max-width: 768px) {
        .header-bar {
            height: 60px;

            .toggle-menu {
                height: 55px;
                line-height: 55px;
                display: block;
            }

            > .logo {
                width: 160px;
                height: 55px;
                padding: 5px;

                figcaption {
                    font-size: 14px;
                }

                img {
                    max-width: 94%;
                }
            }

            .header-data {

                .notifications {
                    .menu-icons .item-icon {
                        width: 40px;
                        height: 45px;
                        line-height: 45px;
                        margin-left: 3px;
                        font-size: 24px;

                        .badge-notify {
                            right: 0;
                            bottom: 0;
                        }
                    }
                }

                .navegation {
                    padding-right: 10px;

                    .user-info {
                        display: none;
                    }

                    .dropmenu-header {
                        width: 45px !important;
                    }

                    .user-avatar {
                        width: 40px;
                        height: 40px;
                    }

                    .menu-icons .item-icon.user {
                        width: 40px;
                        height: 40px;
                        line-height: 40px;
                        font-size: 17px;
                    }
                }
            }
        }
    }

    @media all and (max-width: 540px) {
        .header-bar {
            > .navegation {
                .menu-icons a {
                    margin-left: 1px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Header.vue?27ac9528